<script>

import Layout from "../../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";

import { ref } from "vue";


import { useCountryStore } from '@/store/countryStore'


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
        const countryStore = useCountryStore();


        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          countryStore,

        };
    },
    page: {
    title: "Pays",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Pays",
      items: [
        {
          text: "Définition",
        },
        {
          text: "Pays",
          active: true,
        },
      ],
      errors: [],
      country: {},
      countries: [],
      name_en: "",
      name_fr: "",
      name_pt: "",
      name_ru: "",
      continent: "",
      isoCode: "",
      dialCode: "",
      loading: false,
      status: 201,
    };
  },
  methods: {

  async loadFromStore() {
      if (!this.countryStore.list) {
       await  this.countryStore.loadFromApi(true).then(data => {
        this.countries = data
         this.country_search = data
       })
      } else {
        this.countries = this.countryStore.list
        this.country_search = this.countries
      }
  },

    addItem() {

      this.errors = [];

      let body = {
        "isoCode": this.isoCode,
        "dialCode": this.dialCode,
        "flag": this.flag,
        "name_en": this.name_en,
        "name_fr": this.name_fr,
        "name_pt": this.name_pt,
        "name_ru": this.name_ru,
        "continent": this.continent
      }
      
      this.countryStore.createItem(body);
      this.countries = this.countryStore.list
      this.country_search = this.countries;

    },

      compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },

    editItem() {
      this.errors = [];

      let body = {
        "isoCode": this.isoCode,
        "dialCode": this.dialCode,
        "flag": this.flag,
        "name_en": this.name_en,
        "name_fr": this.name_fr,
        "name_pt": this.name_pt,
        "name_ru": this.name_ru,
        "continent": this.continent
      }

      this.countryStore.editItem(this.country.id, body);
      this.countries = this.countryStore.list
      this.country_search = this.countries
    },

     deleteIt() {
      this.countryStore.deleteItem(this.country.id);
      this.countries = this.countryStore.list
      this.country_search = this.countries
    },

    initItem(country, action="edit") {
      this.country = country
      this.initData(country)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
        this.doesEditOpen = true
      }
    },

    initData(item = null) {
      this.isoCode = item != null ? item.isoCode : ""
      this.dialCode = item != null ? item.dialCode : ""
      this.flag = item != null ? item.flag : ""
      this.continent = item != null ? item.continent : ""
      this.name_fr = item != null ? item.name_fr : ""
      this.name_en = item != null ? item.name_en : ""
      this.name_pt = item != null ? item.name_pt : ""
      this.name_ru = item != null ? item.name_ru : ""
    }

  },

  mounted() {
    this.loadFromStore()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.country = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.country = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3">
        <b-button variant="primary" @click="doesAddOpen = true" class="ms-auto">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Ajouter un nouveau
        </b-button>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des pays</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>pays</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Continent</th>
                    <th>Pays EN</th>
                    <th>Pays FR</th>
                    <th>Pays PT</th>
                    <th>Pays RU</th>
                    <th>dialCode</th>
                    <th>Iso Code</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(country, i) in countries" :key="country.id">
                    <th scope="row"  v-on:click="compileToClipboard(country.id)"
                      style="cursor: pointer">{{ i + 1 }}</th>
                    <td>{{ country.continent }}</td>
                    <td>{{ country.name_en }}</td>
                    <td>{{ country.name_fr }}</td>
                    <td>{{ country.name_pt }}</td>
                    <td>{{ country.name_ru }}</td>
                    <td>{{ country.dialCode }}</td>
                    <td>{{ country.isoCode }}</td>
                    <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(country, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(country, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <router-link :to="'/countries/' + country.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>


    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="md"
        title="Ajouter un pays"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            <div class="col-md-12 mb-3">
                <label for="">Le continent</label>
                <input type="text" required v-model="continent" class="form-control">
                <span class="text-danger mt-2" v-if="errors.continent">{{ errors.continent }}</span>
            </div>
            <div class="col-md-12 mb-3">
                <label for="">Flag</label>
                <input type="text" required v-model="flag" class="form-control">
                <span class="text-danger mt-2" v-if="errors.flag">{{ errors.flag }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Nom EN du pays</label>
              <input type="text" required v-model="name_en" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name_en">{{ errors.name_en }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Nom FR du pays</label>
              <input type="text" required v-model="name_fr" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name_fr">{{ errors.name_fr }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Nom PT du pays</label>
              <input type="text" required v-model="name_pt" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name_pt">{{ errors.name_pt }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Nom RU du pays</label>
              <input type="text" required v-model="name_ru" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name_ru">{{ errors.name_ru }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Indicatif</label>
              <input type="text" required v-model="dialCode" class="form-control">
              <span class="text-danger mt-2" v-if="errors.dialCode">{{ errors.dialCode }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Code Iso</label>
              <input type="text" required v-model="isoCode" class="form-control">
              <span class="text-danger mt-2" v-if="errors.isoCode">{{ errors.isoCode }}</span>
            </div>
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="md"
        title="Modifier un pays"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">
            <div class="col-md-12 mb-3">
              <label for="">Le continent</label>
              <input type="text" required v-model="continent" class="form-control">
              <span class="text-danger mt-2" v-if="errors.continent">{{ errors.continent }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <label for="">Nom EN du pays</label>
            <input type="text" required v-model="name_en" class="form-control">
            <span class="text-danger mt-2" v-if="errors.name_en">{{ errors.name_en }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <label for="">Nom FR du pays</label>
            <input type="text" required v-model="name_fr" class="form-control">
            <span class="text-danger mt-2" v-if="errors.name_fr">{{ errors.name_fr }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <label for="">Nom PT du pays</label>
            <input type="text" required v-model="name_pt" class="form-control">
            <span class="text-danger mt-2" v-if="errors.name_pt">{{ errors.name_pt }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <label for="">Nom RU du pays</label>
            <input type="text" required v-model="name_ru" class="form-control">
            <span class="text-danger mt-2" v-if="errors.name_ru">{{ errors.name_ru }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <label for="">Indicatif</label>
            <input type="text" required v-model="dialCode" class="form-control">
            <span class="text-danger mt-2" v-if="errors.dialCode">{{ errors.dialCode }}</span>
          </div>
          <div class="col-md-12 mb-3">
            <label for="">Code Iso</label>
            <input type="text" required v-model="isoCode" class="form-control">
            <span class="text-danger mt-2" v-if="errors.isoCode">{{ errors.isoCode }}</span>
          </div>
        </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un pays"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer le pays <b>{{ country?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
